export default __webpack_public_path__ + "static/media/gallery_04.1ad7d4d7.jpg";